module.exports = __webpack_public_path__ + "img/navigate-paps.466240ed.jpg";